import { create } from 'zustand';

type ModalState = {
	message: string;
	buttonText?: string;
	isOpen: boolean;
	type?: string;
	payment?: string;
	onConfirm?: () => void; // Add this to store the callback function
	showModal: (message: string, type?: string, buttonText?: string, onConfirm?: () => void) => void;
	clickModal: () => void;
	closeModal: () => void;
};

export const useModalStore = create<ModalState>((set, get) => ({
	message: '',
	buttonText: '로그인 하러가기',
	type: '',
	payment: '',
	isOpen: false,
	onConfirm: undefined, // Initialize the callback
	showModal: (message, type, buttonText = '', onConfirm) => set({ message, type, buttonText, isOpen: true, onConfirm }),
	clickModal: () => {
		// Get the current state to access the onConfirm callback
		const { onConfirm } = get();

		// Execute the callback if it exists
		if (onConfirm) {
			onConfirm();
		}

		// Close the modal after executing the callback
		set({ isOpen: false });
	},
	closeModal: () => set({ isOpen: false, onConfirm: undefined }), // Clear the callback when closing
}));
